import React from 'react';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { ClockIcon, CrossmarkIcon } from 'assets/icons';
import { useFormikField } from 'common/components/form/useFormikField';
import { FieldLabel } from 'common/components/form/Wrapper/FieldLabel';

import { IDateTimeField } from './IDateTimeField';
import {
  DatePickerWrapper,
  RangePickerStyled,
  TimePickerFooter,
  TimePickerFooterText,
  TimePickerStyled,
} from './index.styled';
import { useTheme } from 'styled-components';

export const TimeField = ({ name, label, defaultValue, rangePicker, ...rest }: IDateTimeField) => {
  const { value, setValue, hasError } = useFormikField(name);
  const { t } = useTranslation();
  const { colors } = useTheme();

  const { disableClearIcon } = rest;

  const handleRange = (datetimeRangeUTC: any) => {
    setValue([datetimeRangeUTC[0], datetimeRangeUTC[1]]);
  };

  return (
    <DatePickerWrapper>
      <FieldLabel
        label={label}
        name={name}
        isRequired={rest.required}
        justifyContent={rest.justifyContentLabel}
        tooltip={rest.labelIcon}
      />
      {!rangePicker && (
        <TimePickerStyled
          needConfirm={false}
          {...rest}
          placeholder={t('Select')}
          format="HH:mm"
          name={name}
          defaultValue={defaultValue ?? undefined}
          value={!!value ? dayjs(value, 'HH:mm:ss') : undefined}
          onChange={setValue}
          suffixIcon={<ClockIcon width={24} height={24} stroke={colors.black_40} />}
          allowClear={{
            clearIcon: !disableClearIcon && (
              <CrossmarkIcon width={24} height={24} fill={colors.black_40} />
            ),
          }}
          //status={hasError ? 'error' : undefined}
          $hasError={hasError}
          renderExtraFooter={() => (
            <TimePickerFooter>
              <TimePickerFooterText>h</TimePickerFooterText>
              <TimePickerFooterText>min</TimePickerFooterText>
            </TimePickerFooter>
          )}
        />
      )}

      {rangePicker && (
        <RangePickerStyled
          {...rest}
          onChange={rest.onChange || undefined}
          placeholder={[t('From'), t('To')]}
          format="HH:mm"
          onCalendarChange={rest.onCalendarChange || handleRange}
          value={defaultValue} // important
          disabledTime={() => {
            return {
              disabledMinutes: () => Array.from(Array(59), (_: any, index: number) => index + 1),
            };
          }}
          hideDisabledOptions
          name={name}
          suffixIcon={<ClockIcon width={24} height={24} stroke={colors.black_40} />}
          allowClear={{
            clearIcon: !disableClearIcon && (
              <CrossmarkIcon width={24} height={24} fill={colors.black_40} />
            ),
          }}
        />
      )}
    </DatePickerWrapper>
  );
};
